import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/login"); return; }
    api.post("/auth/session", { session_id: sessionId })
      .then((res) => {
        login(res.data.token, res.data.user);
        window.location.hash = "";
        navigate("/dashboard");
      })
      .catch(() => navigate("/login"));
  }, [navigate, login]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <img src="/nexa-mark.png" alt="NEXA" className="w-12 h-12 rounded-xl object-contain animate-pulse" />
        Autenticazione in corso…
      </div>
    </div>
  );
};

export default AuthCallback;
